import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.861 3.329C18.174 2.626 17 3.124 17 4.117V6.25H3a.75.75 0 0 0 0 1.5h14v2.133c0 .993 1.174 1.49 1.861.788l2.82-2.883a1.133 1.133 0 0 0 0-1.576zM5.139 13.329c.687-.703 1.861-.205 1.861.788v2.133h14a.75.75 0 0 1 0 1.5H7v2.133c0 .993-1.174 1.49-1.861.788l-2.82-2.883a1.133 1.133 0 0 1 0-1.576z"
    }, null, -1)
  ])))
}
export default { render: render }